import { LOCAL_STATIC_BASE } from "../data/env/constants";
import { padStart } from "lodash";

export const padding = (num: number) => {
  return padStart(num.toString(), 6, "0");
};
export const localMiscIconUrlOf = (fileName: string) => {
  return `${LOCAL_STATIC_BASE}/img/misc/${fileName}.webp`;
};
